<template>
  <div class="lltselec flex_start wrap">
    <div
      class="item"
      v-for="(item, index) in 16"
      :key="index"
      @click="clisel(index)"
      :class="{ lltiteact: index == selewtindex }"
    >
      婚姻家事
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    selewtindex: 0,
  }),
  methods: {
    clisel(item) {
      this.selewtindex = item;
      this.$emit("cliwt", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.lltselec {
  width: 1200px;
  margin: 50px auto;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(4, 0, 0, 0.06);
  border-radius: 5px;
  padding: 3px 35px 30px;
  .item {
    width: 84px;
    text-align: center;
    padding: 2px 6px;
    border-radius: 20px;
    color: #000;
    margin-right: 40px;
    margin-top: 30px;
    cursor: pointer;
    position: relative;
    &:hover {
      background: #0465ea;
      color: #fff;
    }
    &.lltiteact {
      background: #0465ea;
      color: #fff;
    }
    &::after {
      content: "";
      position: absolute;
      right: -18px;
      top: 5px;
      width: 1px;
      height: 18px;
      background-color: #999999;
    }
    &:nth-child(9n) {
      &::after {
        display: none;
      }
    }
    &:last-child{
      &::after {
        display: none;
      }
    }
  }
}
</style>